export const types = {
	INIT_DOCUMENTS: "INIT_FORM11_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM11_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM11_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM11_DOCUMENTS",
}

export const initForm11Docs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addForm11Doc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeForm11Doc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetForm11Docs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
